<template>
  <div class="content">
    <div class="tableTit">
      <p class="tabtitBg"></p>
      <h6>注册</h6>
      <el-button class="titBtn" type="primary" icon="el-icon-document-checked" @click="bcData">保存</el-button>
      <el-button class="titBtn" type="warning" icon="el-icon-delete" @click="deleteData">删除</el-button>
      <el-button class="titBtn" type="success" icon="el-icon-download" @click="download">模板下载</el-button>
      <div class="import-s">
        <p class>
          <span class="el-icon-upload2"></span>导入
        </p>
        <input type="file" @change="xzdata($event)" />
        <!---->
      </div>
      <el-button class="titBtn" type="success" icon="el-icon-search" @click="search">搜索</el-button>
      <addressTree @obj="objdata" @close="treeClose"></addressTree>
    </div>
    <div class="tabBody">
      <el-table ref="multipleTable" @selection-change="handleSelectionChange"
        :header-cell-style="{ background: 'rgba(49,130,222,0.1)' }" :data="tabledata" :height="tableHeight" border>
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column type="index" align='center' width="45" label="序号" fixed></el-table-column>
        <el-table-column prop="ydbSheng" align='center' label="省">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbSheng" :disabled="true"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="ydbShi" align='center' label="市">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbShi" :disabled="true"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="ydbXian" align='center' label="县">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbXian" :disabled="true"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="ydbXiang" width="120" align='center' label="乡" :render-header="addRedStar">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbXiang" :disabled="true"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="ydbCun" width="120" align='center' label="村" :render-header="addRedStar">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbCun" :disabled="true"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="ydbName" width="180" align='center' label="淤地坝名称" :render-header="addRedStar">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbName" :disabled="true"></el-input>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="ydbCode" width="180" align='center' label="编码">
            <template slot-scope="scope">
              <el-input v-model="tabledata[scope.$index].ydbCode"></el-input>
            </template>
          </el-table-column> -->
        <el-table-column prop="ydbSfwggb" width="120" align='center' label="类型" :render-header="addRedStar">
          <template slot-scope="scope">
            <el-select v-model="tabledata[scope.$index].ydbSfwggb" placeholder="请选择类型" :disabled="true">
              <el-option label="大型坝" value="大型"></el-option>
              <el-option label="中型坝" value="中型"></el-option>
              <el-option label="小型坝" value="小型"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="ydbSnzc" width="150" align='center' label="枢纽组成" :render-header="addRedStar">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbSnzc" placeholder="请以顿号进行分隔" :disabled="true"></el-input>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="ydbSszl" align='center' label="所在流域" :render-header="addRedStar">
            <template slot-scope="scope">
              <el-input v-model="tabledata[scope.$index].ydbSszl"></el-input>
            </template>
          </el-table-column> -->
        <el-table-column prop="ydbJcnd" width="100" align='center' label="建坝时间(年月)" :render-header="addRedStar"
          :disabled="true">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbJcnd" :disabled="true"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="ydbYxrs" width="150" align='center' label="是否下游有人">
          <template slot-scope="scope">
            <el-select v-model="tabledata[scope.$index].ydbYxrs" placeholder="请选择是否">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="ydbZyss" width="150" align='center' label="是否有重要设施">
          <template slot-scope="scope">
            <el-select v-model="tabledata[scope.$index].ydbZyss" placeholder="请选择是否">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="ydbBwf" width="150" align='center' label="是否百万方以上">
          <template slot-scope="scope">
            <el-select v-model="tabledata[scope.$index].ydbBwf" placeholder="请选择是否">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align='center' label="地理坐标">
          <!-- 经度 -->
          <el-table-column prop="ydbJingDu" width="120" align='center' label="经度" :render-header="addRedStar">
            <template slot-scope="scope">
              <el-input v-model="tabledata[scope.$index].ydbJingDu"></el-input>
            </template>
          </el-table-column>
          <!-- 纬度 -->
          <el-table-column prop="ydbWeiDu" width="120" align='center' label="纬度" :render-header="addRedStar">
            <template slot-scope="scope">
              <el-input v-model="tabledata[scope.$index].ydbWeiDu"></el-input>
            </template>
          </el-table-column>
        </el-table-column>
        <!-- 坝控面积 -->
        <el-table-column prop="ydbKzmj" width="120" align='center' label="坝控面积(km2)" :render-header="addRedStar">
          <template slot-scope="scope">
            <el-input v-model="tabledata[scope.$index].ydbKzmj"></el-input>
          </template>
        </el-table-column>
        <el-table-column align='center' label="基于卫星遥感/无人机影像获取的指标成果">
           <!-- 数据来源 -->
          <el-table-column prop="ydbSjly1" width="150" align='center' label="数据来源" :render-header="addRedStar">
          <template slot-scope="scope">
            <el-select v-model="tabledata[scope.$index].ydbSjly1" placeholder="请选择">
              <el-option label="卫星遥感影像" value="1"></el-option>
              <el-option label="无人机影像" value="0"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="ydbGcjz1" width="150" align='center' label="高程基准" :render-header="addRedStar">
          <template slot-scope="scope">
            <el-select v-model="tabledata[scope.$index].ydbGcjz1" placeholder="请选择">
              <el-option label="大地高程" value="1"></el-option>
              <el-option label="85高程" value="0"></el-option>
            </el-select>
          </template>
        </el-table-column>

          <!-- 已淤面积 -->
          <el-table-column prop="ydbYymj1" width="120" align='center' label="已淤面积(km²)" :render-header="addRedStar">
            <template slot-scope="scope">
              <el-input v-model="tabledata[scope.$index].ydbYymj1"></el-input>
            </template>
          </el-table-column>

          <!-- 剩余库容 -->
          <el-table-column prop="ydbSykr1" width="120" align='center' label="剩余库容(万m³)" :render-header="addRedStar">
            <template slot-scope="scope">
              <el-input v-model="tabledata[scope.$index].ydbSykr1"></el-input>
            </template>
          </el-table-column>

          <!-- 已淤库容 -->
          <el-table-column prop="ydbYykr1" width="120" align='center' label="已淤库容(万m³)" :render-header="addRedStar">
            <template slot-scope="scope">
              <el-input v-model="tabledata[scope.$index].ydbYykr1"></el-input>
            </template>
          </el-table-column>

          <!-- 坝顶高程-->
          <el-table-column prop="ydbBdgc1" width="120" align='center' label="坝顶高程(m)" :render-header="addRedStar">
            <template slot-scope="scope">
              <el-input v-model="tabledata[scope.$index].ydbBdgc1"></el-input>
            </template>
          </el-table-column>
          <!-- 淤积高程-->
          <el-table-column prop="ydbYjgc1" width="120" align='center' label="淤积高程(m)" :render-header="addRedStar">
            <template slot-scope="scope">
              <el-input v-model="tabledata[scope.$index].ydbYjgc1"></el-input>
            </template>
          </el-table-column>
          <!-- 泄洪设施高程-->
          <el-table-column prop="ydbXhssgc1" width="120" align='center' label="泄洪设施高程(m)" :render-header="addRedStar">
            <template slot-scope="scope">
              <el-input v-model="tabledata[scope.$index].ydbXhssgc1"></el-input>
            </template>
          </el-table-column>
          <!-- 坝体背水面坝脚高程-->
          <el-table-column prop="ydbBtbsmBjgc1" width="120" align='center' label="坝体背水面坝脚高程(m)"
            :render-header="addRedStar">
            <template slot-scope="scope">
              <el-input v-model="tabledata[scope.$index].ydbBtbsmBjgc1"></el-input>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column align='center' label="RTX/无人船声纳技术实测获取的指标成果">
          <el-table-column prop="ydbSjly2" width="150" align='center' label="数据来源" :render-header="addRedStar">
          <template slot-scope="scope">
            <el-select v-model="tabledata[scope.$index].ydbSjly2" placeholder="请选择">
              <el-option label="RTK测量" value="1"></el-option>
              <el-option label="RTK测量辅助无人船声呐技术" value="0"></el-option>
            </el-select>
          </template>
        </el-table-column>
          <!-- 高程基准 -->
          <el-table-column prop="ydbGcjz2" width="150" align='center' label="高程基准" :render-header="addRedStar">
          <template slot-scope="scope">
            <el-select v-model="tabledata[scope.$index].ydbGcjz2" placeholder="请选择">
              <el-option label="大地高程" value="1"></el-option>
              <el-option label="85高程" value="0"></el-option>
            </el-select>
          </template>
        </el-table-column>
          <el-table-column prop="ydbBdgc2" width="120" align='center' label="坝顶高程(m)" :render-header="addRedStar">
            <template slot-scope="scope">
              <el-input v-model="tabledata[scope.$index].ydbBdgc2"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="ydbYjgc2" width="120" align='center' label="淤积高程(m)" :render-header="addRedStar">
            <template slot-scope="scope">
              <el-input v-model="tabledata[scope.$index].ydbYjgc2"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="ydbXhssgc2" width="120" align='center' label="泄洪设施高程(m)" :render-header="addRedStar">
            <template slot-scope="scope">
              <el-input v-model="tabledata[scope.$index].ydbXhssgc2"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="ydbBtbsmBjgc2" width="120" align='center' label="坝体背水面坝脚高程(m)"
            :render-header="addRedStar">
            <template slot-scope="scope">
              <el-input v-model="tabledata[scope.$index].ydbBtbsmBjgc2"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="ydbGccjName2" width="120" align='center' label="高程采集人员姓名" :render-header="addRedStar">
            <template slot-scope="scope">
              <el-input v-model="tabledata[scope.$index].ydbGccjName2"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="ydbGccjPhone2" width="120" align='center' label="高程采集人员联系方式"
            :render-header="addRedStar">
            <template slot-scope="scope">
              <el-input v-model="tabledata[scope.$index].ydbGccjPhone2"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="ydbCjtime2" width="120" align='center' label="高程采集时间" :render-header="addRedStar">
            <template slot-scope="scope">
              <el-input v-model="tabledata[scope.$index].ydbCjtime2"></el-input>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <div class="fye">
      <pagintion ref="mypagintion" @dsydata='DsyData' @dstdata="DstData" :total='total' :pageNums="pageNums">
      </pagintion>
    </div>
    <registerSelect v-if="registerSelectShow" @getcancel="Getcancel" @baxing="baxing"></registerSelect>
    <!-- <registerXzpopup v-if="dialogVisible == true" @cancel="registerCancel"></registerXzpopup> -->
  </div>
</template>

<script>
import addressTree from '@/components/mangement/addressTree.vue';
import pagintion from '@/components/mangement/pagintion.vue';
// import registerXzpopup from '../popup/registerXzpopup.vue'
import registerSelect from '@/components/mangement/registerSelect.vue';
import Url from '@/common/js/Url.js';
import axios from "axios";
import {
  selectYdbGcInfo,
  deleteYdbGcInfo,
  initRegion,
  selectRegisteredYdb,
  updateSaveYdbGcInfo,
  preApproveYdb
} from '@/api/api.js'
export default {
  data() {
    return {
      tableHeight: window.innerHeight - 180,
      tabledata: [],
      total: null,
      pageSize: 20, //每页多少条数据分页
      pageNum: 1, //当前页
      pageNums: null,
      multipleSelection: [],
      dialogVisible: false,
      Addsid: [],
      objdata1: null,
      tabledataIndex: 0,
      isSave: false,

      radioNow: '',
      registerSelectShow: false,
    }
  },
  components: {
    addressTree,
    pagintion,
    // registerXzpopup
    registerSelect
  },
  mounted() {
    let params = {
      pageSize: this.pageSize,
      pageNum: this.pageNum,
      ydbName: this.objdata1
    }
    this.list(params)
  },
  methods: {
    //表头加必填符号
    addRedStar(h, {
      column
    }) {
      if (this.radioNow == '') {
        return [
          h("span", " " + column.label),
        ];
      } else {
        return [
          h("span", {
            style: "color: red"
          }, "*"),
          h("span", " " + column.label),
        ];
      }
    },
    addRedStar1(h, {
      column
    }) {
      if (this.radioNow == '小型' || this.radioNow == '') {
        return [
          h("span", " " + column.label),
        ];
      } else {
        return [
          h("span", {
            style: "color: red"
          }, "*"),
          h("span", " " + column.label),
        ];
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    edit(index, row) {
      this.Addsid = ["bj", row];
      this.dialogVisible = true;
    },
    downloadrow(index, row) {
      window.location.href = '/userApi/ydb/basic/downYdbInfo?id=' + row.id;
    },
    treeClose() {
      this.objdata1 = null;
      this.total = null;
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        ydbName: this.objdata1
      }
      this.list(params)
    },
    search() {
      this.tabledata = [];
      this.total = null;
      this.pageSize = 20;
      this.pageNum = 1;
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        ydbName: this.objdata1
      };
      this.list(params)
    },

    objdata(data) {
      this.objdata1 = data;
    },
    DsyData(data) { //多少页
      this.pageNum = data.dsy;
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        ydbName: this.objdata1
      }
      this.list(params)
    },
    DstData(data) { //多少条
      this.pageSize = data.dst;
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        ydbName: this.objdata1
      }
      this.list(params)
    },
    download() {
      const regionCode = this.$store.state.regionCode;
      console.log("!!!", regionCode);
      window.location.href = '/userApi/ydb/gcInfo/downYdbGcInfo?regionCode=' + regionCode;
    },

    list(params) {
      this.tabledata = [];
      selectYdbGcInfo(params).then((res) => {
        console.log("3.22上午", res.data)
        //  this.total = res.total;
        this.tabledata = res.data;
      })
    },
    xzdata(e) {
      let file = e.target.files[0];
      let filename = file.name.split(".")[
        file.name.split(".").length - 1
      ];

      let filenames = file.name;
      let fileSize = file.size / 1024 / 1024 < 1000000;

      if (fileSize) {
        if (filename != "xlsx") {
          this.$notify({
            title: "提示",
            message: "请选择xls文件",
            type: "success",
          });
          e.target.value = null;
        } else {
          let formData = new FormData();
          formData.append("file", file);
          /*formData.append("importFile", file);
          formData.append("no", this.treeno);
          formData.append("proId", this.proID);*/
          let config = {
            headers: {
              "Content-Type": "multipart/form-data",
              //"login-token": this.$store.state.logintoken,
            },
          }; // 添加请求头

          axios.post("/ydb/gcInfo/import", formData, config).then((res) => {
            if (res.data.code == 200) {
              this.$notify({
                title: "提示",
                message: res.data.message,
                type: "success",
              });
              let params = {
                pageSize: this.pageSize,
                pageNum: this.pageNum,
                ydbName: this.objdata1
              };
              this.list(params);
              e.target.value = null;
            } else {
              this.$notify({
                title: "提示",
                message: res.data.message,
                type: "warning",
              });
            }
          }).catch((err) => { });
        }
      } else {
        this.$message({
          message: "文件不能大于10M",
          type: "success",
        });
        e.target.value = null;
      }
    },

    //新增一条记录
    xzData() {
      console.log(this.tabledata)
      this.registerSelectShow = true;
      this.radioNow = '';
    },

    //提交审核
    auditing() {
      // console.log("提交审核")
      let _this = this;
      if (this.isSave == false) {
        this.$notify({
          title: "提示",
          message: "请先进行数据保存！",
          type: "warning",
        });
      } else {
        if (this.multipleSelection.length == 0) {
          this.$notify({
            title: "提示",
            message: "请选择要提交审核的数据！",
            type: "warning",
          });
        } else {
          preApproveYdb(this.multipleSelection).then((res) => {
            if (res.code == 200) {
              this.$notify({
                title: "提示",
                message: "提交审核成功！",
                type: "success",
              });
              let params = {
                pageSize: this.pageSize,
                pageNum: this.pageNum,
                ydbName: this.objdata1
              };
              this.list(params);
              this.isSave = false;
            } else {
              this.$notify({
                title: "提示",
                message: "提交审核失败！",
                type: "error",
              });
            }
          });
        }
      }
    },

    //保存
    bcData() {
      // console.log("保存", this.multipleSelection)
      if (this.multipleSelection.length === 0) {
        this.$notify.error({
          title: "错误",
          message: "请选择要保存的数据！"
        });
      } else {
        updateSaveYdbGcInfo(this.multipleSelection).then(res => {
          if (res.code === 200) {
            this.$notify.success({
              title: "成功",
              message: "数据保存成功！"
            });
            let params = {
              pageSize: this.pageSize,
              pageNum: this.pageNum
            };
            this.list(params);
          } else {
            this.$notify.error({
              title: "错误",
              message: res.message
            });
          }
        }).catch(err => {
          console.error(err);
          this.$notify.error({
            title: "错误",
            message: "保存数据时发生错误！"
          });
        });
      }
    },
    deleteData() {
      // console.log("保存", this.multipleSelection)
      if (this.multipleSelection.length === 0) {
        this.$notify.error({
          title: "错误",
          message: "请选择要删除的数据！"
        });
      } else {
        const idArray = this.multipleSelection.map(item => item.id);
        console.log("3.22",idArray);
        deleteYdbGcInfo(idArray).then(res => {
          if (res.code === 200) {
            this.$notify.success({
              title: "成功",
              message: "数据删除成功！"
            });
            let params = {
              pageSize: this.pageSize,
              pageNum: this.pageNum
            };
            this.list(params);
          } else {
            this.$notify.error({
              title: "错误",
              message: res.message
            });
          }
        }).catch(err => {
          console.error(err);
          this.$notify.error({
            title: "错误",
            message: "删除数据时发生错误！"
          });
        });
      }
    },
    baxing(type) {
      let _this = this;
      this.registerSelectShow = false;
      this.radioNow = type;
      this.tabledataIndex += 1;
      initRegion().then((res) => {
        // console.log(res)
        if (res.sheng[0] && res.shi[0] && res.xian[0]) {
          _this.tabledata.push({
            tabledataIndex: _this.tabledataIndex,
            ydbSheng: res.sheng[0].regionName,
            ydbShengCode: res.sheng[0].regionCode,
            ydbShi: res.shi[0].regionName,
            ydbShiCode: res.shi[0].regionCode,
            ydbXian: res.xian[0].regionName,
            ydbXianCode: res.xian[0].regionCode,
            ydbXiang: '',
            ydbCun: '',
            ydbName: '',
            ydbCode: '',
            ydbSfwggb: this.radioNow,
            ydbSnzc: '',
            ydbSszl: '',
            ydbJcnd: '',
            ydbKzmj: '',
            ydbBaGao: '',
            ydbBdcd: '',
            ydbZkr: '',
            ydbDhkr: '',
            ydbSjyjkr: '',
            ydbYykr: '',
            ydbSjyjmj: '',
            ydbYyjmj: '',
            ydbJingDu: '',
            ydbWeiDu: '',
            ydbSfgj: '',
            ydbSfcxjg: '',
            ydbSfljb: '',
            ydbBxsltj: '',
            ydbSfxygzsj: '',
            ydbSfxyxsly: '',
            ydbSfbzyhgbyt: '',
            ydbBtlf: '0',
            ydbBthptt: '0',
            ydbBtcqcg: '0',
            ydbBtgysl: '0',
            ybdFsjzwwgsj: '0',
            ydbFsjzwhdhg: '0',
            ydbFsjzwmq: '0',
            ydbXsjzwmq: '0',
            ydbXsjzwtsxk: '0',
            ydbXsjzwqt: '0',
            ydbDlbt: '0',
            ydbLabpbwd: '0',
            ydbYxrs: 0,
            ydbZyss: '',
            ydbJkss: '',
            ydbGlzrzt: '',
            ydbYwghbc: '',
            ydbQtwtsm: '',
            ydbLx: '注册',
          });
        } else {
          this.$notify({
            title: "提示",
            message: "您没有权限新增记录！",
            type: "warning",
          });
        }
      });
    },

    Getcancel(data) {
      this.registerSelectShow = false;
    },
  }
}
</script>

<style scoped>
@import url('../../../common/css/mangementall.css');

.zblxtree {
  width: 230px;
  height: calc(100% - 80px);
  height: -webkit-calc(100% - 80px);
  height: -moz-calc(100% - 80px);
  background: #f7f7f7;
  border-radius: 6px;
  float: left;
  overflow: auto;
  padding: 15px;
}

.zblxtreeSty {
  background: #f7f7f7;
  border-radius: 6px;
}

.tablelist {
  width: 100%;
  height: calc(100% - 50px);
  height: -webkit-calc(100% - 50px);
  height: -moz-calc(100% - 50px);
  float: right;
  position: relative;
}

.tablelistbox {
  width: 100%;
  heigt: 100%;
}

.clsjTis {
  position: absolute;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
  margin: auto;
  width: 335px;
  height: 210px;
  border: 1px solid #cccccc;
  background: #f7f7f7;
  border-radius: 6px;
  font-size: 16px;
}

.ycllxname {
  float: left;
  line-height: 30px;
  font-size: 14px;
  margin-left: 10px;
  margin-top: 10px;
}

.cllx-select {
  float: left;
  margin-top: 10px;
  width: 230px;
}

.btn {
  position: absolute;
  bottom: 10px;
  right: 10px;
}

.zzct {
  font-size: 20px;
  margin-right: 10px;
}

.import-s {
  float: right;
  position: relative;
  width: 100px;
  height: 28px;
  background: #409eff;
  margin-right: 10px;
  border-radius: 4px;
  margin-top: 11px;
  overflow: hidden;
}

.import-s p {
  position: absolute;
  width: 100%;
  line-height: 28px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
}

.import-s p span {
  margin-right: 5px;
}

.import-s input {
  width: 100%;
  height: 28px;
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.el-input__inner {
  height: 30px;
  line-height: 30px;
  color: #606266;
  font-size: 14px;
  padding: 0;
  padding-left: 5px;
}
</style>